import { DataGrid } from '@innovyze/stylovyze';
import { createStyles, makeStyles, styled } from '@mui/styles';

export const useRiskMatrixStyles = makeStyles(() =>
	createStyles({
		header: {
			backgroundColor: '#f7f7f7',
			justifyContent: 'space-evenly',
		},
		lofcofheadercell: {
			display: 'flex',
			alignItems: 'center',
			padding: '10px 10px 0',
			fontWeight: 'bold',
		},
		lofCell: {
			fontWeight: 'bold',
			'&:before': { content: '"\\2264"' },
			'& > div:nth-of-type(1)': {
				width: '2.5rem',
				display: 'inline-block',
				textAlign: 'right',
			},
		},
		doneIcon: {
			width: '1.3rem',
			marginRight: '3px',
		},
		dummyIcon: {
			width: '1.3rem',
			marginRight: '3px',
			color: '#ffffff',
		},
		fwdIcon: { marginLeft: '0px', width: '16px' },
		downIcon: { width: '16px' },
		gridCellContainer: {
			overflow: 'hidden',
			cursor: 'pointer',
			padding: '0 10px',
		},
		cellButton: {
			color: '#3c3c3c',
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
		},
		matrixHeaderContainer: {
			height: '60px',
			display: 'flex',
			backgroundColor: '#ffffff',
			padding: '0.9375rem 0.9375rem 0.9375rem 1.5rem',
			alignItems: 'center',
		},
		matrixHeaderText: {
			margin: '5px',
			fontStyle: 'normal',
			fontSize: '18px',
			fontWeight: '600',
			color: '#272833',
		},
		matrixFooterContainer: {
			backgroundColor: '#ffffff',
			height: '70px',
			display: 'flex',
			alignItems: 'center',
			flexDirection: 'row-reverse',
		},
		matrixFooterLegendDiv: { display: 'flex', alignItems: 'center' },
		matrixFooterEditBtn: { margin: '10px 10px 10px 0px' },
		matrixFooterPreviewBtn: { margin: '10px' },
		legendsList: {
			display: 'flex',
			alignItems: 'center',
			backgroundColor: '#ffffff',
			height: '50px',
			padding: '10px',
			borderTop: '2px solid #e7e7ed',
		},
		legendSpans: {
			fontSize: '11px',
			color: '#999999',
			margin: '0px 15px 0px 2px',
		},
		gridCellMenuItemContainer: {
			display: 'flex',
			justifyContent: 'flex-start',
		},
		gridCellMenuItemDoneIconContainer: {
			position: 'absolute',
			right: '12px',
		},
		gridCellMenuItemDoneIcon: {
			width: '1.5rem',
			margin: '0px 3px 4px 0px',
		},
		gridCellMenuItemLegendName: { textTransform: 'capitalize' },
		gridCellMenuItemIconContainer: { marginRight: '-8px' },
		dialogBoxStyle: {
			minWidth: '700px',
		},
		rangeEditorDivider: {
			margin: '10px 0px 5px 0px',
		},
		contentBody: {
			'& .ContentCard--body': {
				padding: '0.6rem 1.5rem 0.7rem 1.5rem',
			},
		},
	}),
);

export const StyledRiskMatrixDataGrid = styled(DataGrid)(() => ({
	height: '100%',
	width: '100%',
	'& .lofHeaderCellClass': {
		backgroundColor: '#f7f7f7',
		borderRight: '2px solid #e7e7ed',
	},
	'& .scoreCell': {
		backgroundColor: '#ffffff',
	},
}));
